import { useState } from 'react';

import { SearchMonthSingleForm } from 'src/components/common/form/search/SearchMonthSingleForm';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';

import { useTQC2090_R01Store } from './Store_TQC2090_R01';

/** 검사연월 조회조건 영역. 사업장은 1000 고정이고 공정라인은 탭으로 고른다. */
export const SearchSection_TQC2090_R01 = () => {
	const { TQC2090_R01Filter, setTQC2090_R01Filter } = useTQC2090_R01Store();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	return (
		<SearchSectionForm>
			<SearchMonthSingleForm
				label="검사연월"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				value={TQC2090_R01Filter.inspectYm}
				onChange={(date) => setTQC2090_R01Filter({ inspectYm: date })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
		</SearchSectionForm>
	);
};
